import { Route, Routes } from 'react-router-dom';
import Home from '../../components/Main/Home/Home';
import Login from '../../components/Main/Login/Login';
import GestioneAvvisi from '../../components/Main/Avvisi/GestioneAvvisi/GestioneAvvisi';
import GestioneAvviso from '../../components/Main/Avvisi/GestioneAvviso/GestioneAvviso';
import { RoleRoute } from '../../guards/logged';
import { NotLoggedRoute } from '../../guards/notLogged';
import { RoleGuardRoute } from '../../guards/roleGuardRoute';
import App from '../../App';
import { rolesCodes } from '../Roles';
import GestioneFasi from '../../components/Main/Fasi/GestioneFasi/GestioneFasi';
import GestioneFase from '../../components/Main/Fasi/GestioneFase/GestioneFase';
import GestioneLibreria from '../../components/Main/Librerie/GestioneLibreria/GestioneLibreria';
import GestioneAnagraficaComuni from '../../components/Main/AnagraficaComuni/GestioneAnagraficaComuni/GestioneAnagraficaComuni';
import GestioneAnagraficaOperatori from '../../components/Main/AnagraficaOperatori/GestioneAnagraficaOperatori/GestioneAnagraficaOperatori';
import GestioneAnagraficaOperatore from '../../components/Main/AnagraficaOperatori/GestioneAnagraficaOperatore/GestioneAnagraficaOperatore';
import GestioneAnagraficaComune from '../../components/Main/AnagraficaComuni/GestioneAnagraficaComune/GestioneAnagraficaComune';
import GestioneAnagraficaLibrerie from '../../components/Main/Librerie/GestioneAnagraficaLibrerie/GestioneAnagraficaLibrerie';
import SceltaRuolo from '../../components/Main/SceltaRuolo/SceltaRuolo';
import Dashboard from '../../components/Main/Dashboard/Dashboard';
import GestioneIndirizziStudio from '../../components/Main/IndirizziStudio/GestioneIndirizziStudio/GestioneIndirizziStudio';
import GestioneIndirizzoStudio from '../../components/Main/IndirizziStudio/GestioneIndirizzoStudio/GestioneIndirizzoStudio';
import GestioneRichiesta from '../../components/Main/GestioneRichiesta/GestioneRichiesta';
import PresaVisione from '../../components/Main/PresaVisione/PresaVisione';
import DatiUtente from '../../components/Main/DatiUtente/DatiUtente';
import { PresaVisioneGuard } from '../../guards/presaVisioneGuard';
import GestioneDomande from '../../components/Main/GestioneDomande/GestioneDomande';
import ErroriMassivi from '../../components/Main/ErroriMassivi/ErroriMassivi';
import GestioneEventi from '../../components/Main/GestioneEventi/GestioneEventi';
import AggiornamentoIsee from '../../components/Main/GestioneRichiesta/AggiornamentoIsee/AggiornamentoIsee';
import SecondoAccesso from '../../components/Main/GestioneRichiesta/SecondoAccesso/SecondoAccesso';
import TerzoAccesso from '../../components/Main/GestioneRichiesta/TerzoAccesso/TerzoAccesso';
import GestioneEmailMassivi from '../../components/Main/GestioneEmailMassivi/GestioneEmailMassivi';
import RettificaIban from '../../components/Main/RettificaIban/RettificaIban';
import GestionePagamenti from '../../components/Main/GestionePagamenti/GestionePagamenti';
import GestioneIstruttorie from '../../components/Main/GestioneIstruttorie/GestioneIstruttorie';
//import RettificaRipresentazione from '../../components/Main/GestioneRichiesta/RettificaRipresentazione/RettificaRipresentazione';
import GestioneStatoDomande from '../../components/Main/GestioneStatoDomande/GestioneStatoDomande';
import GestioneAnpr from '../../components/Main/Anpr/GestioneAnpr';
import GestioneGruppiRevoche from '../../components/Main/GestioneGruppiRevoche/GestioneGruppiRevoche';
import GestioneGruppoRevoche from '../../components/Main/GestioneGruppiRevoche/GestioneGruppoRevoche';
import DettaglioRichiesta from '../../components/Main/GestioneRichiesta/DettaglioRichiesta';

const ROUTES = [
    {
        path: '*',
        exact: true,
        element: <NotLoggedRoute><Login /></NotLoggedRoute>
    },
    {
        path: 'dashboard',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><Dashboard ></Dashboard></RoleGuardRoute>
    },
    {
        path: 'aggiornamento-isee/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><AggiornamentoIsee ></AggiornamentoIsee></RoleGuardRoute>
    },
    {
        path: 'secondo-accesso/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><SecondoAccesso ></SecondoAccesso></RoleGuardRoute>
    },
    {
        path: 'terzo-accesso/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><TerzoAccesso ></TerzoAccesso></RoleGuardRoute>
    },
    {
        path: 'gestione-avvisi',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin, rolesCodes.regione]}><GestioneAvvisi /></RoleGuardRoute>
    },
    {
        path: 'gestione-avviso',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin, rolesCodes.regione]}><GestioneAvviso /></RoleGuardRoute>
    },
    {
        path: 'gestione-avviso/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin, rolesCodes.regione]}><GestioneAvviso /></RoleGuardRoute>
    },
    {
        path: 'gestione-fasi',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin, rolesCodes.regione]}><GestioneFasi /></RoleGuardRoute>
    },
    {
        path: 'gestione-fase',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin, rolesCodes.regione]}><GestioneFase /></RoleGuardRoute>
    },
    {
        path: 'gestione-fase/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin, rolesCodes.regione]}><GestioneFase /></RoleGuardRoute>
    },
    {
        path: 'gestione-librerie/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comune, rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaLibrerie /></RoleGuardRoute>
    },
    {
        path: 'gestione-libreria/:enteId',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comune, rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneLibreria /></RoleGuardRoute>
    },
    {
        path: 'gestione-libreria/:enteId/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comune, rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneLibreria /></RoleGuardRoute>
    },
    {
        path: 'gestione-comuni-librerie',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comune, rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaComuni /></RoleGuardRoute>
    },
    {
        path: 'gestione-adesione-enti',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comune, rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaComuni /></RoleGuardRoute>
    },
    {
        path: 'gestione-anagrafica-comune',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneAnagraficaComune /></RoleGuardRoute>
    },
    {
        path: 'gestione-anagrafica-comune/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneAnagraficaComune /></RoleGuardRoute>
    },
    {
        path: 'gestione-richiesta',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><GestioneRichiesta /></RoleGuardRoute>
    },
    {
        path: 'gestione-richiesta/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><GestioneRichiesta /></RoleGuardRoute>
    },
    // {
    //     path: 'gestione-anagrafica-comune/:bandoId',
    //     exact: true,
    //     element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneAnagraficaComune /></RoleGuardRoute>
    // },
    // {
    //     path: 'gestione-anagrafica-comune/:bandoId/:id',
    //     exact: true,
    //     element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneAnagraficaComune /></RoleGuardRoute>
    // },
    {
        path: 'gestione-operatori',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comune, rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaOperatori /></RoleGuardRoute>
    },
    {
        path: 'gestione-operatori/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comune, rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaOperatori /></RoleGuardRoute>
    },
    {
        path: 'gestione-anagrafica-operatore',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaOperatore /></RoleGuardRoute>
    },
    {
        path: 'gestione-anagrafica-operatore/:enteId',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaOperatore /></RoleGuardRoute>
    },
    {
        path: 'gestione-anagrafica-operatore/:enteId/:userId',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaOperatore /></RoleGuardRoute>
    },
    {
        path: 'anagrafica-referente/:enteId',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaOperatore /></RoleGuardRoute>
    },
    {
        path: 'anagrafica-referente/:enteId/:userId',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.comuneReferente, rolesCodes.regione]}><GestioneAnagraficaOperatore /></RoleGuardRoute>
    },
    {
        path: 'gestione-indirizzi-studio/',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneIndirizziStudio /></RoleGuardRoute>
    },
    {
        path: 'gestione-indirizzo-studio/',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneIndirizzoStudio /></RoleGuardRoute>
    },
    {
        path: 'gestione-indirizzo-studio/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneIndirizzoStudio /></RoleGuardRoute>
    },    
    {
        path: 'gestione-domande',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneDomande /></RoleGuardRoute>
    },
    {
        path: 'gestione-errori',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><ErroriMassivi /></RoleGuardRoute>
    },
    {
        path: 'gestione-eventi',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneEventi /></RoleGuardRoute>
    },
     {
        path: 'gestione-email',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneEmailMassivi /></RoleGuardRoute>
    },
    {
        path: 'dati-utente',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><PresaVisioneGuard><DatiUtente /></PresaVisioneGuard></RoleGuardRoute>
    },
    {
        path: 'presa-visione',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><RoleRoute><PresaVisione /></RoleRoute></RoleGuardRoute>
    },
    {
        path: 'scelta-ruolo',
        exact: true,
        element: <RoleRoute><SceltaRuolo /></RoleRoute>
    },
    {
        path: 'gestione-pagamenti',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestionePagamenti /></RoleGuardRoute>
    },
    {
        path: 'gestione-istruttorie',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneIstruttorie /></RoleGuardRoute>
    },
    {
        path: 'gestione-stato-domande',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.regione]}><GestioneStatoDomande /></RoleGuardRoute>
    },
    {
        path: 'home',
        exact: true,
        element: <RoleRoute><Home /></RoleRoute>
    },
        {
        path: 'rettifica-iban',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><RettificaIban /></RoleGuardRoute>
    },
    {
        path: 'gestione-anpr',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin, rolesCodes.regione]}><GestioneAnpr /></RoleGuardRoute>
    },
    {
        path: 'gestione-revoche',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin,rolesCodes.regione]}><GestioneGruppiRevoche /></RoleGuardRoute>
    },
    {
        path: 'gestione-gruppo-revoche',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin, rolesCodes.regione]}><GestioneGruppoRevoche /></RoleGuardRoute>
    },
    {
        path: 'dettaglio-richiesta/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.admin,rolesCodes.regione]}><DettaglioRichiesta /></RoleGuardRoute>
    }
   /* {
        path: 'rettifica-ripresentazione/:id',
        exact: true,
        element: <RoleGuardRoute roles={[rolesCodes.cittadino]}><RettificaRipresentazione ></RettificaRipresentazione></RoleGuardRoute>
    },*/
    
];

export const router = 
    <Routes>
        <Route path='*' element={<App />}>
            {
                ROUTES.map((route) => (
                    <Route exact={route.exact} key={route.path} path={route.path} element={route.element} loader={route.loader} />
                ))
            }
        </Route>
    </Routes>;
